export default {"src":"/_next/static/media/img-at-bg.2e079e5b.svg","height":150,"width":151,"blurWidth":0,"blurHeight":0};